/**
 * Uncapitalizes the provided string value.
 *
 * @param {string} value the value to uncapitalize
 * @returns {string} the uncapitalized value
 */
export function uncapitalize(value: string): string {
  return value.charAt(0).toLowerCase() + value.slice(1);
}
